import { render, staticRenderFns } from "./Backorders.vue?vue&type=template&id=34613d6e"
import script from "./Backorders.vue?vue&type=script&lang=js"
export * from "./Backorders.vue?vue&type=script&lang=js"
import style0 from "./Backorders.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports